import React from 'react';
import LinkComp from '../LinkComp';
import svgAngleDoubleLeft from '../../svgs/angle-double-left.svg';
import svgAngleDoubleRight from '../../svgs/angle-double-right.svg';
import Icon from '../Icon';
import PropTypes from 'prop-types';

const Paginate = (props) => {
	const page = props.page ? Number(props.page) : 1;
	const itemCount = props.originalItemCount ? props.originalItemCount : props.itemCount;

	if (!props.itemCount) {
		return null;
	}

	let hasMore;
	if (props.totalCount !== false) {
		// totalCount is known — use it directly so client-side filtered pages
		// (where itemCount < limit) don't incorrectly suppress pagination.
		hasMore = props.limit * page < props.totalCount;
	} else {
		// totalCount unknown — infer from whether a full page was returned.
		hasMore = itemCount > 0 && itemCount === props.limit;
	}

	// Nothing to navigate: on the first page with no further results.
	if (!hasMore && page <= 1) {
		return null;
	}

	const prevQuery = Object.assign({}, props.query, {page: page - 1});
	const nextQuery = Object.assign({}, props.query, {page: page + 1});

	if (prevQuery.page <= 1) {
		delete prevQuery.page;
	}

	if (!hasMore) {
		delete nextQuery.page;
	}

	return (
		<div className='Paginate'>
			<LinkComp to={{pathname: props.pathname, query: prevQuery}} rel="prev" disabled={page <= 1}>
                <div className='button-new negative'>Previous</div>
			</LinkComp>
			<LinkComp to={{pathname: props.pathname, query: nextQuery}} rel="next" disabled={!hasMore}>
                <div className='button-new positive'>Next</div>
			</LinkComp>
		</div>
	);
};

Paginate.propTypes = {
    pathname: PropTypes.string.isRequired,
	query: PropTypes.object.isRequired,
	limit: PropTypes.number.isRequired,
	page: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
	totalCount: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.bool,
    ]).isRequired,
	itemCount: PropTypes.number.isRequired,
    originalItemCount: PropTypes.number,
};

export default Paginate;